// app/javascript/controllers/combobox_controller.js
import { Controller } from "@hotwired/stimulus"
import { useClickOutside } from "stimulus-use"

export default class extends Controller {
  static targets = ["input", "hiddenInput", "optionsList", "option"]

  connect() {
    // Utilise le mixin pour fermer la combobox si on clique ailleurs
    useClickOutside(this, { element: this.element })
    this.highlightedIndex = -1
  }

  // Action pour ouvrir/fermer la liste d'options
  toggle(event) {
    event.preventDefault()
    this.optionsListTarget.classList.toggle("hidden")
  }

  // Action pour fermer la liste (appelée par useClickOutside)
  clickOutside(event) {
    this.close()
  }

  // Ferme la liste d'options
  close() {
    this.optionsListTarget.classList.add("hidden")
    this.unhighlightAll()
    this.highlightedIndex = -1
  }

  // Action appelée quand on tape du texte dans l'input
  filter() {
    const query = this.inputTarget.value.toLowerCase()
    this.optionTargets.forEach(option => {
      const text = option.innerText.toLowerCase()
      option.classList.toggle("hidden", !text.includes(query))
    })
    this.optionsListTarget.classList.remove("hidden") // Ouvre la liste si elle est fermée
  }

  // Action appelée quand on clique sur une option
  select(event) {
    const selectedOption = event.currentTarget
    this.inputTarget.value = selectedOption.innerText.trim()
    this.hiddenInputTarget.value = selectedOption.dataset.value

    this.close()
  }

  // Gère la navigation au clavier
  navigate(event) {
    if (this.optionsListTarget.classList.contains("hidden")) {
      if (event.key === "ArrowDown" || event.key === "ArrowUp") {
        this.optionsListTarget.classList.remove("hidden")
      }
    }

    switch (event.key) {
      case "ArrowDown":
        event.preventDefault()
        this.highlightNext()
        break
      case "ArrowUp":
        event.preventDefault()
        this.highlightPrevious()
        break
      case "Enter":
        event.preventDefault()
        if (this.highlightedIndex >= 0) {
          this.optionTargets[this.highlightedIndex].click()
        }
        break
      case "Escape":
        this.close()
        break
    }
  }

  highlightNext() {
    this.unhighlightAll()
    this.highlightedIndex++
    if (this.highlightedIndex >= this.visibleOptionTargets.length) {
      this.highlightedIndex = 0
    }
    this.highlight(this.highlightedIndex)
  }

  highlightPrevious() {
    this.unhighlightAll()
    this.highlightedIndex--
    if (this.highlightedIndex < 0) {
      this.highlightedIndex = this.visibleOptionTargets.length - 1
    }
    this.highlight(this.highlightedIndex)
  }

  highlight(index) {
    const option = this.visibleOptionTargets[index]
    if (option) {
      option.classList.add("bg-sz-primary-600", "text-white")
      option.scrollIntoView({ block: 'nearest' })
    }
  }

  unhighlightAll() {
    this.optionTargets.forEach(option => {
      option.classList.remove("bg-sz-primary-600", "text-white")
    })
  }
  
  // Getter pour ne récupérer que les options visibles (non filtrées)
  get visibleOptionTargets() {
    return this.optionTargets.filter(target => !target.classList.contains('hidden'))
  }
}